import { useTranslation } from 'react-i18next';
import type { AnalyticsValue } from './data.ts';

export function UnavailableReason({ reason }: { reason: AnalyticsValue['unavailable_reason'] | undefined }) {
  const { t } = useTranslation();
  if (!reason) return null;
  return <span className="mt-1 block max-w-64 whitespace-normal text-xs font-normal leading-relaxed text-amber-800" data-testid="ana-unavailable-reason">{t(`training.dsoReasons.${reason}`)}</span>;
}
